import type { BaseRouteType, BaseMethodType } from '../types.ts'
import { z } from "zod";
export const tagsPatchBuildingsReorder = z.any()
export type TagsPatchBuildingsReorder = z.infer<typeof tagsPatchBuildingsReorder>

export const bodyPatchBuildingsReorder = z.object({ "updates": z.array(z.object({ "id": z.string(), "order": z.number() })) })
export type BodyPatchBuildingsReorder = z.infer<typeof bodyPatchBuildingsReorder>

export const responsePatchBuildingsReorder = z.any()
export type ResponsePatchBuildingsReorder = z.infer<typeof responsePatchBuildingsReorder>

interface IPatchBuildingsReorder extends BaseMethodType {
  tags: TagsPatchBuildingsReorder,
  body: BodyPatchBuildingsReorder,
  response: ResponsePatchBuildingsReorder
}
export const URL = '/buildings/reorder'
export const validation = {
  patch: {
    tags: tagsPatchBuildingsReorder,
    body: bodyPatchBuildingsReorder,
    response: responsePatchBuildingsReorder
  }
}
export interface BuildingsReorder extends BaseRouteType {
  patch: IPatchBuildingsReorder
}